import styled from '@emotion/styled';

import Popover from '@material-ui/core/Popover';

export default styled(Popover)`

  .btn {
    background-color: #05B2DC;
    color: #FFF;
    border-radius: 10px;
    font-size: 14px;
    text-decoration: none;
    margin-left: 2px;
    text-transform: none;
  }

  .MuiOutlinedInput-root {
    font-size: 14px;
    background: #F0F0F0;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;